module.exports = require("babel-runtime/helpers/typeof");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/typeof"
// module id = 4
// module chunks = 0